
import "@/styles/pages/recordScreenOnline/index.css";
import ysFixWebmDuration from "./fix-webm-duration.js";
import QRCode from "qrcode";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // record-screen-online
// record-screen-online.php
/* eslint-disable */

new Vue({
	created($, apower, LazyLoad) {

		let gumStream;
		let gdmStream;
		let recorder;
		let recordingData = [];
		let recorderStream;
		let cameraStream;
		const isMac = /Mac/i.test(window.navigator.userAgent);
		let useMic = false;
		let useAudio = isMac ? false : true;
		let useCamera = false;
		let cameraIniting = false;
		const width = 480;
		const height = 320;
		let recordedSeconds = 0;
		let recordedCountTime = 0;
		let videoName = null;
		let recordStatus = 'setting';
		let client;
		let hasCamera;
		let hasMicrophone;
		let countTimer = null;
		let isReadyCounting = false;
		let fileUploading = false;
		let bindFn = null;
		let formatedVideoUrl;
		let fixedVideoBlob = null;
		let userMediaOptions = { video: true, audio: false };
		let displayMediaOptions = { video: false, audio: false };
		const previewVideo = document.getElementById("preview-video");
		const cameraVideo = document.getElementById("camera-video");
		const langMap = new Map([["ar", "en"], ["el", "en"], ["cs", "cz"], ["ja", "jp"], ["da", "dk"], ["sv", "se"], ["kr", "en"]]);
		const lang = langMap.get(apower.lang) || apower.lang;
		const langCode = langMap.get(apower.lang) || lang;
		const recHref = lang == "zh" ? "https://reccloud.cn" : lang == "en" ? "https://reccloud.com" : `https://reccloud.com/${langCode}`;
		const baseUrl = apower.user.isDev() ? "https://devaw.aoscdn.com/tech" : apower.lang == "zh" ? "https://aw.aoscdn.com/tech" : "https://gw.aoscdn.com/tech";

		const inBrowser = typeof window !== "undefined";
		const UA = inBrowser && window.navigator.userAgent.toLowerCase();
		const isEdge = UA && UA.indexOf("edge/") > 0;
		const isFirefox = UA && UA.indexOf("firefox") > 0;
		const isSafari = UA && UA.indexOf("chrome") < 0 && UA.indexOf("safari") > 0;
		const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
		let hasAudioTracks = false; //是否存在音轨, 用于处理提取字幕视频
		let shareUrl = "";//用于分享的url\
		let isClickShare = false;

		function handleVideoOptions() {
			//非中英文不显示提取字幕
			if (apower.lang === "zh" || apower.lang === "en") {
			} else {
				const subtitles = document.querySelector("#subtitles");
				subtitles.style.display = "none";
			}

			const mask = document.querySelector(".options-container-mask");
			const enableOptions = () => {
				$("#video-options").addClass("active");
			};

			const disableOptions = () => {
				if (!previewVideo.paused) {
					$("#video-options").removeClass("active");
				}
			};
			mask.removeEventListener("mouseenter", enableOptions);
			mask.addEventListener("mouseenter", enableOptions);

			mask.removeEventListener("mouseleave", disableOptions);
			mask.addEventListener("mouseleave", disableOptions);

			previewVideo.removeEventListener("pause", enableOptions);
			previewVideo.addEventListener("pause", enableOptions);
			let timer = null
			mask.onmousemove = (ev) => {
				enableOptions();
				clearTimeout(timer);
				timer = setTimeout(() => {
					disableOptions();
				}, 2700);
			};
			if (previewVideo.paused) {
				enableOptions()
			}
		}

		(function checkDevices() {
			// console.log('type support')
			// console.log('video/mp4', MediaRecorder.isTypeSupported('video/mp4'))
			// console.log('video/webm', MediaRecorder.isTypeSupported('video/webm'))
			triggerMediaChecked();
			navigator.mediaDevices.enumerateDevices().then(devices => {
				devices.forEach(device => {
					if (device.kind === "videoinput") hasCamera = true;
					if (device.kind === "audioinput") hasMicrophone = true;
				})
			})
		})()


		// 复写header entry click事件

		$.extend($.getComponent("header-account-entry").prototype, {
			onClick() {
				if (!apower.user.isLogined()) {
					apower.user.popupLoginWin(null, true);
				}
			},
		})


		function triggerMediaChecked() {
			if (useCamera) {
				$("#trigger-camera").addClass('active');
				$("#chooseCamera").addClass('active');
			} else {
				$("#trigger-camera").removeClass('active');
				$("#chooseCamera").removeClass('active');
			}
			if (useMic) {
				$("#trigger-microphone").addClass('active');
				$("#chooseMic").addClass('active');
			} else {
				$("#trigger-microphone").removeClass('active');
				$("#chooseMic").removeClass('active');
			}
			if (useAudio) {
				$("#trigger-sound").addClass('active');
				$("#chooseAudio").addClass('active');
			} else {
				$("#trigger-sound").removeClass('active');
				$("#chooseAudio").removeClass('active');
			}
		}
		$("#trigger-screen").off("click").on('click', () => {
			$("#getAppTip").css('display', 'flex');
			$("#getAppDefaultContent").show();
			$("#macAudioNotSupport").css('display', 'none');
			$("#noDisplayMedia").css('display', 'none');
		})
		$("#trigger-camera").off("click").on('click', () => {
			if (hasCamera) {
				if (cameraIniting) return;
				useCamera = !useCamera;
				triggerMediaChecked();
				changeUseCamera();
			} else {
				$("#noCameraTip").css('display', 'flex');
			}
		})
		$("#trigger-sound").off("click").on('click', () => {
			useAudio = !useAudio;
			if (isMac && useAudio) {
				$("#getAppTip").css('display', 'flex');
				$("#getAppDefaultContent").css('display', 'none');
				$("#noDisplayMedia").css('display', 'none');
				$("#macAudioNotSupport").show();
			}
			triggerMediaChecked();
		})
		$("#trigger-microphone").off("click").on('click', async () => {
			if (hasMicrophone) {
				useMic = !useMic;
				triggerMediaChecked();
			} else {
				$("#noMicTip").css('display', 'flex');
			}
		})
		$("#closeGetAppDialogIcon").off("click").on('click', () => {
			$("#getAppTip").css('display', 'none');
		})

		registerCloudSpace()

		/**
		 * 云空间时间绑定
		 */
		function registerCloudSpace() {
			const spaceBtn = document.querySelector("#cloud-space-btn");
			if (spaceBtn) {
				spaceBtn.onclick = () => {
					const token = apower.user.apiToken;
					let href = `${_getUrl()}/user/`;
					if (token) {
						href += `?api_token=${token}`;
					}
					window.open(href, "_blank");
				};
			}
		}

		function changeUseCamera() {
			if (useCamera) {
				initPreviewCamera();
				if ('pictureInPictureEnabled' in document) {
					cameraVideo.style.opacity = 0;
					cameraVideo.style.zIndex = -10;
					cameraVideo.style.display = 'none';
				} else {
					cameraVideo.style.opacity = 1;
					cameraVideo.style.zIndex = 1000;
					cameraVideo.style.display = 'block';
				}
			} else {
				cancelPreviewCamera();
			}
		}
		// if need double click camera view to enter picture-in-picture mode
		// $("#camera-video").dblclick(function() {
		// 	console.log('db')
		// })
		async function initPreviewCamera() {
			cameraIniting = true;
			try {
				cameraStream = await navigator.mediaDevices.getUserMedia({ video: true });
				cameraVideo.srcObject = cameraStream;
				cameraVideo.addEventListener('canplaythrough', () => {
					cameraIniting = false;
					if ('pictureInPictureEnabled' in document) cameraVideo.requestPictureInPicture();
				})
				// when enter picture-in-picture mode
				cameraVideo.addEventListener('enterpictureinpicture', function (event) {
					cameraVideo.style.opacity = 0;
					cameraVideo.style.zIndex = -10;
				});
				// when exit picture-in-picture mode
				cameraVideo.addEventListener('leavepictureinpicture', function (event) {
					cancelPreviewCamera();
				});
			} catch (e) {
				// 授权失败弹窗
				showNotAllowedTip();
				cameraIniting = false;
				useCamera = false;
				$("#trigger-camera").removeClass('active');
			}
		}
		function cancelPreviewCamera() {
			useCamera = false;
			$("#trigger-camera").removeClass('active');
			if (document.pictureInPictureElement) document.exitPictureInPicture();
			cameraVideo.style.display = 'none';
			cameraVideo.style.opacity = 0;
			cameraVideo.style.zIndex = -10;
			let stream = cameraVideo.srcObject;
			if (stream) {
				let tracks = stream.getTracks();
				for (let i = 0; i < tracks.length; i++) {
					let track = tracks[i];
					track.stop();
				}
			}
			cameraVideo.srcObject = null;
		}

		$("#subStartBtn").off("click").on("click", () => {
			if (recordStatus == 'setting') {
				$("#onlineScreenBox").css('display', 'flex');
				$("#oldMainBox").hide();
				startRecord();
			}
		})
		$("#start-record").off("click").on('click', startRecord)
		async function startRecord() {
			userMediaOptions = { video: useCamera ? { width: width, height: height } : false, audio: useMic };
			displayMediaOptions = { video: true, audio: useAudio };
			if (useMic) {
				const ok = await initUserMedia();
				if (!ok) return;
				initDisplayMedia(displayMediaOptions);
			} else {
				initDisplayMedia(displayMediaOptions);
			}
		}
		async function initDisplayMedia(options) {
			try {
				if(isEdge || isChrome) {
					// show step tips
					const showedScreenGuide = localStorage.getItem('showedScreenGuide');
					if (!showedScreenGuide) {
						$(".screen-recorder-container .step-guides").fadeIn(400);
						localStorage.setItem('showedScreenGuide', 'true');
					}
				}
				gdmStream = await navigator.mediaDevices.getDisplayMedia(options);
				readyCountDown(gdmStream);
				// hide guide after share or cancel or some error
				hideStepGuides();
				gdmStream.getVideoTracks()[0].addEventListener('ended', () => {
					if (isReadyCounting) {
						$("#countdownBox").css('display', 'none');
						cancelPreviewCamera();
						clearInterval(countTimer);
						backToSetting();
						const countNum = document.getElementById('countdownNum');
						countNum.innerText = 3;
						isReadyCounting = false;
						recordedSeconds = 0;
					}
				})
				pointUpload({
					event: "record_start",
					webcam: useCamera,
					system_sound: useAudio,
					microphone: useMic
				}).then();
			} catch (e) {
				// hide guide after share or cancel or some error
				hideStepGuides();
				console.log(e)
				console.log(e.name)
				console.log(e.message)
				if (e.name == 'NotFoundError' || e.message == 'The object can not be found here.' || e.name == 'TypeError') {
					$("#getAppTip").css('display', 'flex');
					$("#getAppDefaultContent").css('display', 'none');
					$("#noDisplayMedia").show();
					$("#macAudioNotSupport").css('display', 'none');
				} else {
					$(".light-top-tip").addClass('active');
					let tipTimer = setTimeout(() => {
						$(".light-top-tip").removeClass('active');
						clearTimeout(tipTimer);
					}, 2000)
				}
				cancelPreviewCamera();
				console.log('授权失败！')
			}
		}
		async function initUserMedia() {
			try {
				gumStream = await navigator.mediaDevices.getUserMedia({ audio: useMic });
				return true;
			} catch (e) {
				showNotAllowedTip();
				useMic = false;
				$("#trigger-microphone").removeClass('active');
				return false;
			}
		}
		function readyCountDown(stream) {
			$("#closeOnlineRecorder").hide();
			showLongTimeTip();
			isReadyCounting = true;
			videoName = null;
			recordStatus = 'recording';
			recordingData = [];
			triggerMediaChecked();
			changeDisplayBlock();
			$("#countdownBox").css('display', 'flex');
			const countNum = document.getElementById('countdownNum');
			let start = 3;
			countTimer = setInterval(() => {
				if (start > 1) {
					start -= 1;
					countNum.innerText = start;
				} else if (start == 1) {
					start -= 1;
					$("#countdownBox").css('display', 'none');
				} else {
					clearInterval(countTimer);
					startMediaRecord(stream);
					countNum.innerText = 3;
					isReadyCounting = false;
				}
			}, 1000)
		}
		async function startMediaRecord(gdmStream) {
			recorderStream = gumStream ? mixStream(gumStream, gdmStream) : gdmStream;
			const options = isEdge || isChrome ? { mimeType: 'video/webm',codecs: 'H264' } : { mimeType: 'video/webm' };
			recorder = new MediaRecorder(recorderStream, options);

			recorder.start();
			recorder.ondataavailable = function (e) {
				if (e.data && e.data.size > 0) {
					recordingData.push(e.data);
				}
			};
			recorder.onstart = () => {
				$("#start-record").attr("disabled", true);
				$("#stop-record").removeAttr("disabled");
				$("#pause-record").removeAttr("disabled");
				startCountdown();
			};
			recorder.onstop = () => {
				pointUpload({
					event: "record_end"
				});
				if (document.pictureInPictureElement) document.exitPictureInPicture();
				stopCountdown();
				if (recordStatus == 'recording' || recordStatus == 'pause') {
					recordStatus = "preview";
					$("#onlineScreenBox").addClass("preview-main-box");
					$("#recordOnlineTitle").hide();
					videoName = getVideoFilename() + ".webm";
					hasAudioTracks = recorder.stream.getAudioTracks().length > 0;
					toggleSubtitleState(hasAudioTracks);

					const blob = new Blob(recordingData, { type: 'video/webm' });
					ysFixWebmDuration(blob, recordedSeconds).then(fixedBlob => {
						pointUpload({
							event: "creat_file_success",
							file_size: (fixedBlob.size / 1024 / 1024).toFixed(2),
							file_time: (recordedSeconds / 1000).toFixed(2)
						});
						fixedVideoBlob = fixedBlob;
						initPreviewVideo();
					})
					// $("#formatShadow").css('display', 'flex');
					// changeVideoType();
				}
				$("#pause-record").removeClass("record-resume");
				$("#pause-record").addClass("record-pause");
				$(".pause-resume-word.resume").hide();
				$(".pause-resume-word.pause").show();
				$("#saveAsMp4").hide();
				$("#downloadRecordVideo").show();
				$("#goBackDialog").css('display', 'none');
				recorder = null;
				cancelPreviewCamera();
				changeDisplayBlock();
			};
			recorder.onpause = () => {
				stopCountdown();
			}
			recorder.onresume = () => {
				startCountdown();
			}
			recorderStream.addEventListener('inactive', () => {
				// console.log('Capture stream inactive');
			});
			recorderStream.getVideoTracks()[0].addEventListener('ended', () => {
				stopMediaRecord();
			})
		}

		function mixStream(gumStream, gdmStream) {
			let tracks = [];
			// console.log("gumStream tracks", gumStream.getAudioTracks(), gumStream.getVideoTracks());
			// console.log("gdmStream tracks", gdmStream.getAudioTracks(), gdmStream.getVideoTracks());
			if (useMic && !useAudio) {
				if (gumStream.getAudioTracks().length > 0) tracks = tracks.concat(gumStream.getAudioTracks());
			} else if (useAudio && !useMic) {
				if (gdmStream.getAudioTracks().length > 0) tracks = tracks.concat(gdmStream.getAudioTracks());
			} else if (useAudio && useMic) {
				const ctx = new AudioContext();
				const dest = ctx.createMediaStreamDestination();
				if (gumStream.getAudioTracks().length > 0) ctx.createMediaStreamSource(gumStream).connect(dest);
				if (gdmStream.getAudioTracks().length > 0) ctx.createMediaStreamSource(gdmStream).connect(dest);
				tracks = tracks.concat(dest.stream.getTracks());
			}
			tracks = tracks.concat(gumStream.getVideoTracks()).concat(gdmStream.getVideoTracks());
			// console.log("mixed tracks", tracks)
			return new MediaStream(tracks)
		}

		function stopMediaRecord() {
			$("#start-record").removeAttr("disabled");
			$("#stop-record").attr("disabled", true);
			$("#pause-record").attr("disabled", true);
			if (recorderStream) recorderStream.getTracks().forEach(track => track.stop());
			if (gumStream) gumStream.getTracks().forEach(track => track.stop());
			if (gdmStream) gdmStream.getTracks().forEach(track => track.stop());
			if (cameraStream) cameraStream.getTracks().forEach(track => track.stop());
			$("#preview-video").attr('controls', true);
		}

		$("#stop-record").off("click").on('click', stopMediaRecord);
		function initPreviewVideo() {
			let src = window.URL.createObjectURL(fixedVideoBlob);
			previewVideo.src = src;

			const questionContainer = document.querySelector(".question-container");
			if (questionContainer) {
				questionContainer.onclick = function(ev) {
					const item = ev.target;
					if (item.classList.contains("save-mp4")) {
						toConverterPage();
					} else if (item.classList.contains("cloud-rec")) {
						const token = apower.user.apiToken;
						let href = `${_getUrl()}/user/`;
						if (token) {
							href += `?api_token=${token}`;
						}
						window.open(href, "_blank");
					}


					const items = questionContainer.querySelectorAll(".question-item");
					let target = item;
					if (item.tagName.toUpperCase() === "A") {
						target = item.parentElement;
					}
					const index = Array.from(items).indexOf(target);
					pointUpload({
						event: "click_faq",
						faq: index + 1
					}).then();
				};
			}
		}

		function _getUrl() {
			const isDev = apower.user.isDev();
			const langMap = new Map([["ar", "en"], ["el", "en"], ["cs", "cz"], ["ja", "jp"], ["da", "dk"], ["sv", "se"], ["kr", "en"]]);
			const lang = langMap.get(apower.lang) || apower.lang;
			const langCode = langMap.get(apower.lang) || lang;
			let recHref = lang === "zh" ? "https://reccloud.cn" : lang === "en" ? "https://reccloud.com" : `https://reccloud.com/${langCode}`;
			if (isDev) {
				recHref =
					lang === "zh"
						? "https://dev-reccloud-cn.aoscdn.com"
						: lang === "en"
							? "https://dev-reccloud-com.aoscdn.com"
							: `https://dev-reccloud-com.aoscdn.com/${langCode}`;
			}

			return recHref;
		}

		function toConverterPage() {
			let url = "https://www.apowersoft.com/free-online-video-converter";
			const saveMp4Dom = document.getElementById("saveAsMp4");
			if (saveMp4Dom && saveMp4Dom.href) {
				url = saveMp4Dom.href;
			}
			window.open(url, "_blank");
		}

		function changeDisplayBlock() {
			switch (recordStatus) {
				case "setting":
					$("#recordSetting").css("display", "block");
					$("#recordCounting").css("display", "none");
					$("#recordPreview").css("display", "none");
					break;
				case "recording":
					$("#recordSetting").css("display", "none");
					$("#recordCounting").css("display", "block");
					$("#recordPreview").css("display", "none");
					break;
				case "pause":
					$("#recordSetting").css("display", "none");
					$("#recordCounting").css("display", "block");
					$("#recordPreview").css("display", "none");
					break;
				case "preview":
					$("#recordSetting").css("display", "none");
					$("#recordCounting").css("display", "none");
					$("#recordPreview").css("display", "block");
					break;
				default:
					$("#recordSetting").css("display", "block");
					$("#recordCounting").css("display", "none");
					$("#recordPreview").css("display", "none");
					break;
			}
		}

		function formatMilliseconds(ms) {
			// 1- Convert to seconds:
			var seconds = ms / 1000;

			// 2- Extract hours:
			var hours = parseInt(seconds / 3600); // 3600 seconds in 1 hour
			seconds = parseInt(seconds % 3600); // extract the remaining seconds after extracting hours

			// 3- Extract minutes:
			var minutes = parseInt(seconds / 60); // 60 seconds in 1 minute

			// 4- Keep only seconds not extracted to minutes:
			seconds = Math.ceil(seconds % 60);

			// 5 - Format so it shows a leading zero if needed
			let hoursStr = ("00" + hours).slice(-2);
			let minutesStr = ("00" + minutes).slice(-2);
			let secondsStr = ("00" + seconds).slice(-2);

			return hoursStr + ":" + minutesStr + ":" + secondsStr
		}
		let recordingCountdown;
		const spanRecordingDuration = document.getElementById('recordedTime');
		function startCountdown() {
			$('.recording-animation .dotting').addClass('active');
			const startedAt = (new Date()).getTime();
			let fnCountdown = function () {
				let current = (new Date()).getTime();
				recordedCountTime = (current - startedAt);
				let diff = formatMilliseconds(recordedSeconds + recordedCountTime);
				spanRecordingDuration.innerText = diff;
			};
			recordingCountdown = self.setInterval(fnCountdown, 1000);
			fnCountdown();
		}

		function stopCountdown() {
			$(".recording-animation .dotting").removeClass("active");
			// 暂停时记录已经录制的时间加上新录制的时长
			recordedSeconds += recordedCountTime;
			clearInterval(recordingCountdown);
			recordedCountTime = 0;
		}

		const dbName = "videoDB";
		const tableName = "videos";

		function openDB(dbName, version = 1) {
			return new Promise((resolve) => {
				let db; // 存储创建的数据库
				// 打开数据库，若没有则会创建
				const request = indexedDB.open(dbName, version);

				// 数据库打开成功回调
				request.onsuccess = function(event) {
					db = event.target.result; // 存储数据库对象
					resolve(db);
				};

				// 数据库打开失败的回调
				request.onerror = function() {
				};

				// 数据库有更新时候的回调
				request.onupgradeneeded = function(event) {
					db = event.target.result;
					// 创建存储库
					db.createObjectStore(tableName, {
						keyPath: "id"
					});
				};
			});
		}

		function addData(db, storeName, data) {
			return new Promise((resolve, reject) => {
				const request = db
					.transaction([storeName], "readwrite") // 事务对象 指定表格名称和操作模式（"只读"或"读写"）
					.objectStore(storeName) // 仓库对象
					.add(data);

				request.onsuccess = function() {
					// console.log("数据写入成功");
					resolve();
				};

				request.onerror = function() {
					// console.log("数据写入失败");
					reject();
				};
			});
		}

		function deleteDB(db, storeName, id) {
			return new Promise((resolve, reject) => {
				const request = db
					.transaction([storeName], "readwrite")
					.objectStore(storeName)
					.delete(id);

				request.onsuccess = function() {
					resolve();
				};

				request.onerror = function() {
					resolve();
				};
			});
		}

		/**
		 * 将录制blob保存到indexedDB数据库
		 * @param fixedVideoBlob {Blob}
		 */
		async function saveToDB(fixedVideoBlob) {
			const db = await openDB(dbName, 1);
			await deleteDB(db, tableName, "1");
			await addData(db, tableName, { id: "1", filename: videoName, value: fixedVideoBlob });
		}

		function toggleSubtitleState(enable) {
			document.querySelector("#subtitles").classList.toggle("disable", !enable);
			document.querySelector("#audio").classList.toggle("disable", !enable);
		}

		$("#video-options").off("click").on("click", (ev) => {
			let pathname = "";
			let enable = true;
			let functionName = "";
			if (ev.target) {
				switch (ev.target.id) {
					case "crop":
						pathname = "/crop-video-online";
						functionName = "crop_video";
						break;
					case "subtitles":
						pathname = "/speech-to-text-online";
						enable = hasAudioTracks;
						functionName = "video_to_text";
						break;
					case "gif":
						pathname = "/video-to-gif-online";
						functionName = "video_to_gif";
						break;
					case "trim":
						pathname = "/trim-video-online";
						functionName = "trim_video";
						break;
					case "speed":
						pathname = "/adjust-video-speed";
						functionName = "adjust_speed";
						break;
					case "audio":
						pathname = "/extract-audio-online";
						enable = hasAudioTracks;
						functionName = "extrace_audio";
						break;
					default:
						break;
				}
				if (pathname && enable) {
					pointUpload({
						event: "click_online_edit",
						function: functionName
					}).then();
					saveToDB(fixedVideoBlob).then(() => {
						const url = `${pathname}?key=Chrome-Online-Recorder`;
						window.open(url, "_blank");
					});
				}
			}
		});

		handleVideoOptions();

		$("#downloadRecordVideo").off("click").on("click", () => {
			pointUpload({
				event: "click_download_file"
			}).then();
			// const blob = new Blob(recordingData, { type: 'video/webm' });
			const url = window.URL.createObjectURL(fixedVideoBlob);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = formatedVideoUrl || url;
			a.download = videoName;
			document.body.appendChild(a);
			a.click();
			setTimeout(() => {
				document.body.removeChild(a);
				window.URL.revokeObjectURL(url);
				// if($("#saveAsMp4").length > 0) {
				// 	$("#downloadRecordVideo").hide();
				// 	$("#saveAsMp4").show();
				// }
			}, 100);
		});
		function getVideoFilename() {
			let padTo2Digits = function (num) {
				return num.toString().padStart(2, "0");
			}

			let date = new Date();
			let time = [
				date.getFullYear(),
				padTo2Digits(date.getMonth() + 1),
				padTo2Digits(date.getDate()),
				padTo2Digits(date.getHours()),
				padTo2Digits(date.getMinutes()),
				padTo2Digits(date.getSeconds())
			].join("-");
			return "recording-" + time;
		}

		let reccloudURL = apower.lang == "zh" ? "https://aw.aoscdn.com/app/reccloud/v2" : "https://gw.aoscdn.com/app/reccloud/v2";
		if (apower.user.isDev()) {
			reccloudURL = apower.lang === "zh" ? "https://devaw.aoscdn.com/app/reccloud/v2" : "https://gwdev.aoscdn.com/app/reccloud/v2";
		}

		$("#uploadRecordVideo").off("click").on("click", clickUploadBtn);
		$("#shareRecordVideo").off("click").on("click", handleShare);

		function handleShare() {
			pointUpload({
				event: "click_share_file"
			}).then();
			if (shareUrl) {
				openShareDialog(shareUrl);
			} else {
				isClickShare = true;
				clickUploadBtn();
			}
		}

		/**
		 * 打开分享弹窗
		 * @param url
		 */
		function openShareDialog(url) {
			const shareDialog = document.querySelector("#shareDialog");
			if (shareDialog) {
				if (lang === "zh") {
					const imgContainer = shareDialog.querySelector(".app-tip-img-container");
					QRCode.toDataURL(url)
						.then(resultUrl => {
							imgContainer.innerHTML = `<img id="app-qrcode-id" src="${resultUrl}" width="100%" height="100%" style="display: block;"/>`;
						})
						.catch(err => {
							console.error(err);
						});
					const copyImgBtn = shareDialog.querySelector("#copy-img-code");
					copyImgBtn.onclick = function() {
						const img = document.querySelector("#app-qrcode-id");
						const file = convertBase64ToBlob(img.src, "image/png");
						const clipboardItemInput = new ClipboardItem({
							"image/png": file
						});
						navigator.clipboard.write([clipboardItemInput]).then(copySuccessToast);
					};
				}

				const closeBtn = shareDialog.querySelector("#closeShareBtn");
				closeBtn.onclick = function() {
					shareDialog.style.display = "none";
				};

				const copyUrlBtn = shareDialog.querySelector("#copy-url");
				copyUrlBtn.onclick = function() {
					navigator.clipboard.writeText(url).then(copySuccessToast);
				};

				const input = shareDialog.querySelector(".url-input");
				input.value = url;
				shareDialog.style.display = "flex";

				function copySuccessToast() {
					$(".copy-success-tip").addClass('active');
					let tipTimer = setTimeout(() => {
						$(".copy-success-tip").removeClass('active');
						clearTimeout(tipTimer);
					}, 2000)
				}
			}
		}

		function convertBase64ToBlob(imageEditorBase64, type) {
			var base64Arr = imageEditorBase64.split(",");
			var imgtype = type;
			var base64String = "";
			if (base64Arr.length > 1) {
				base64String = base64Arr[1];
			}
			// 将base64解码
			var bytes = atob(base64String);
			//var bytes = base64;
			var bytesCode = new ArrayBuffer(bytes.length);
			// 转换为类型化数组
			var byteArray = new Uint8Array(bytesCode);

			// 将base64转换为ascii码
			for (var i = 0; i < bytes.length; i++) {
				byteArray[i] = bytes.charCodeAt(i);
			}

			// 生成Blob对象（文件对象）
			return new Blob([bytesCode], { type: imgtype });
		}

		function clickUploadBtn(event) {
			if (event) {
				//存在event就是手动点击
				pointUpload({
					event: "click_upload_file"
				}).then();
			}
			if (!fileUploading) {
				const progressNum = document.getElementById("progressNum");
				$("#progressCircle").css("stroke-dashoffset", 372);
				progressNum.innerText = 0;
				$("#uploadFailDialog").css("display", "none");
				if (!apower.user.isLogined()) {
					// 避免重复调用登录弹窗但未登录回调时间被绑定多次重复执行，判断是否已绑定过，绑定过参数传null，在登录后回调执行完成后释放bindFn
					const fn = bindFn ? null : getUserInfo;
					if (!bindFn) bindFn = getUserInfo;
					apower.user.popupLoginWin(fn, true);
				} else {
					getUserInfo();
				}
			}
		}
		async function getUserInfo() {
			fileUploading = true;
			const userId = apower.user.info.user_id;
			const apiToken = apower.user.apiToken;
			let { ok, data } = await $.req.get(`${reccloudURL}/users/${userId}`, {
				headers: {
					Authorization: "Bearer " + apiToken
				}
			});
			if (ok) {
				if (data.data.quota.storage.limit > data.data.quota.storage.used && data.data.quota.quantity.limit > data.data.quota.quantity.used) {
					authorizationFile();
				} else {
					if (data.data.quota.quantity.limit <= data.data.quota.quantity.used) {
						const numBox = document.getElementById("video-limit-num");
						numBox.innerText = data.data.quota.quantity.limit;
						$("#videoNumLimitTip").css('display', 'flex');
					} else if (data.data.quota.storage.limit <= data.data.quota.storage.used) {
						$("#storageLimitTip").css('display', 'flex');
					}
					isClickShare = false;
					fileUploading = false;
				}
			}
		}
		async function authorizationFile() {
			const posts = {
				filenames: [videoName]
			}
			let { ok, data } = await $.req.post(`${reccloudURL}/authorizations/oss`, posts);
			let authentications;
			if (ok) {
				authentications = data.data;
				if (!window.OSS) {
					await $.loadScript(`${window.CDNDOMAIN}/lib/aliyun-oss-sdk.min.js`);
				}
				client = new OSS({
					region: authentications.region,
					accessKeyId: authentications.credential.access_key_id,
					accessKeySecret: authentications.credential.access_key_secret,
					stsToken: authentications.credential.security_token,
					bucket: authentications.bucket,
					secure: true,
					endpoint: authentications.endpoint,
				});
			}
			uploadFileToOss(authentications);
		}
		async function uploadFileToOss(authentications) {
			$("#uploadingDialog").css('display', 'flex');
			if(recordingData.length == 0) return;
			const data = fixedVideoBlob;
			const file = new File([data], videoName, { type: 'video/mp4' });
			let key = authentications.objects[videoName];
			let url = authentications["callback"]["url"];
			let callbackBody = authentications["callback"]["body"];
			let name = encodeURI(videoName);
			let callback = {
				url: url,
				body: callbackBody.replace("${filename}", name) + '&x:object=' + key + '&x:endpoint=' + authentications.endpoint + '&x:bucket=' + authentications.bucket + '&x:user_id=' + apower.user.info.user_id,
				contentType: authentications["callback"]["type"]
			};
			const option = {
				cancelFlag: true,
				callback: callback,
				progress: uploadProgress,
				partSize: 500 * 1024,
			}
			pointUpload({
				event: "upload_start"
			}).then();

			client.multipartUpload(key, file, option).then(function (res) {
				if (res.data.status == 200) {
					const videoInfo = res.data.data;
					editDefaultVideo(videoInfo);
					const info = {
						event: "upload_success",
						file_size: (parseInt(videoInfo.size) / 1024 / 1024).toFixed(2),
						file_time: parseInt(videoInfo.duration) / 1000,
						source_from: "ap_online_recorder"
					}
					pointUpload(info)
					pointUpload(info, true);
				} else {
					isClickShare = false;
					fileUploading = false;
					$("#uploadingDialog").css('display', 'none');
					$("#uploadFailDialog").css('display', 'flex');
				}
			}, function(reason) {
				const info = {
					event: "upload_failed",
					reason: reason.toString()
				}
				pointUpload(info);
				pointUpload(info, true);
			})
		}
		function uploadProgress(progress) {
			let pro = Math.ceil(progress * 100);
			const base = 372;
			let pronum = base - (base / 100) * pro;
			$("#progressCircle").css('stroke-dashoffset', pronum);
			const progressNum = document.getElementById('progressNum');
			progressNum.innerText = pro;
			if (progress == 1) {
				bindFn = null;
			}
		}
		// reccloud的视频需要调一次编辑接口，才会在网站上显示出来
		async function editDefaultVideo(videoInfo) {
			const posts = {
				title: videoName,
				app_lang: langCode,
				permission: 2,
				app_id: 'Chrome Online Recorder',
				app_version: 'V1.0',
			}
			const apiToken = apower.user.apiToken;
			const { ok, data } = await $.req.put(`${reccloudURL}/videos/${videoInfo.uniqid}`, posts, { headers: { Authorization: "Bearer " + apiToken } });
			if (ok) {
				const token = apower.user.apiToken;
				const href = `${data.data.video_open_url}?api_token=${token}`;
				shareUrl = data.data.video_open_url;
				$("#uploadingDialog").css("display", "none");
				const progressNum = document.getElementById("progressNum");
				$("#progressCircle").css("stroke-dashoffset", 372);
				progressNum.innerText = 0;
				if (isClickShare) {
					openShareDialog(shareUrl);
				} else {
					window.open(href, "_blank");
				}

			}
			isClickShare = false;
			fileUploading = false;
		}
		// $("#saveAsMp4").off("click").on("click", saveAsMp4);
		async function saveAsMp4() {
			await $.loadScript("https://dev-cdn-apowersoft-com.aoscdn.com/ffmpeg/ffmpeg-mp4-web.js");
			window.prompt = () => 'video.webm';
			var fileReader = new FileReader();
			var fileData;
			fileReader.onload = function () {
				const outName = videoName.replace(".webm", ".mp4");
				fileData = this.result;
				const testData = new Uint8Array(fileData);
				const result = ffmpeg({
					MEMFS: [{name: "video.webm", data: testData}],
					arguments: ["-i", "video.webm", "-c:v", "copy", outName],
				});
				// download mp4
				const out = result.MEMFS[0];
				const blob = new File([out.data], outName, { type: 'video/mp4' });
				const url = URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.style.display = 'none';
				a.href = url;
				a.download = outName;
				document.body.appendChild(a);
				a.click();
				setTimeout(() => {
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
				}, 100);
			};
			fileReader.readAsArrayBuffer(fixedVideoBlob);
		}

		function hideStepGuides() {
			$(".screen-recorder-container .step-guides").fadeOut(50);
		}
		let tipTimer;
		let tipShowTime;
		function showLongTimeTip() {
			if(tipTimer) clearTimeout(tipTimer);
			// show long time tips
			const showedLongScreenRecordTip = localStorage.getItem('showedLongScreenRecordTip');
			if (!showedLongScreenRecordTip) {
				tipShowTime = new Date().getTime();
				$(".long-time-tip").addClass('active');
				addTipTimer();
			}
		}
		$(".long-time-tip").hover(function () {
			clearTimeout(tipTimer);
		}, function () {
			const timeNow = new Date().getTime();
			if (timeNow - tipShowTime >= 10000) {
				$(".long-time-tip").removeClass('active');
			} else {
				let leftTime = 10000 - (timeNow - tipShowTime);
				addTipTimer(leftTime);
			}
		})
		function addTipTimer(duration) {
			let time = duration || 10000;
			tipTimer = setTimeout(() => {
				$(".long-time-tip").removeClass('active');
				clearTimeout(tipTimer);
			}, time);
		}
		$("#closeLongTimeTip").off("click").on("click", hideLongTimeTip)
		function hideLongTimeTip() {
			$(".long-time-tip").removeClass('active');
			localStorage.setItem('showedLongScreenRecordTip', 'true');
		}

		$("#cancelUpload").off("click").on("click", () => {
			client.cancel();
			$("#uploadingDialog").css('display', 'none');
			closeUploadFailDialog();
		});
		$("#closeUploadFailBtn").off("click").on("click", closeUploadFailDialog);
		$("#uploadAgainBtn").off("click").on("click", clickUploadBtn);
		function closeUploadFailDialog() {
			$("#uploadFailDialog").css('display', 'none');
			fileUploading = false;
		}
		$("#goBackDialog").css('display', 'none');
		$(".pause-resume-word.resume").hide();
		$("#goBackTitle").off("click").on("click", () => {
			$("#goBackDialog").show();
			$("#goBackDialog").css('display', 'flex');
		});

		$("#recordNewTitle").off("click").on("click", backToSetting);

		$("#cancelBack").off("click").on("click", () => {
			$("#goBackDialog").css('display', 'none');
		})

		$("#confirmBack").off("click").on("click", () => {
			$("#goBackDialog").css('display', 'none');
			$("#start-record").removeAttr("disabled");
			$("#stop-record").attr("disabled", true);
			$("#pause-record").attr("disabled", true);
			stopCountdown();
			backToSetting();
		})
		function backToSetting() {
			$("#closeOnlineRecorder").show();
			recordStatus = "setting";
			$("#onlineScreenBox").removeClass('preview-main-box');
			$("#recordOnlineTitle").show();
			const spanRecordingDuration = document.getElementById('recordedTime');
			spanRecordingDuration.innerText = '00:00:00';
			previewVideo.src = null;
			$("#saveAsMp4").hide();
			$("#downloadRecordVideo").show();
			recordedSeconds = 0;
			recordedCountTime = 0;
			triggerMediaChecked();
			changeDisplayBlock();
			stopMediaRecord();
		}
		$("#closeCameraTip").off("click").on("click", () => {
			$("#noCameraTip").css('display', 'none');
		})
		$("#closeMicTip").off("click").on("click", () => {
			$("#noMicTip").css('display', 'none');
		})
		$("#closeOnlineRecorder").off("click").on("click", () => {
			$("#onlineScreenBox").css('display', 'none');
			$("#oldMainBox").show();
			backToSetting();
			gumStream = null;
			gdmStream = null;
			recorder = null;
			cameraStream = null;
			recorderStream = null;
			recordingData = [];
		})
		function showNotAllowedTip() {
			$("#notAllowedTip").css("display", "flex");
		}
		$("#hideNotAllowedTip").off("click").on("click", () => {
			$("#notAllowedTip").css("display", "none");
		})
		$("#closeStorageLimitTip").off("click").on("click", () => {
			$("#storageLimitTip").css('display', 'none');
		})
		$("#closeVideoNumLimitTip").off("click").on("click", () => {
			$("#videoNumLimitTip").css('display', 'none');
		})
		$(".to-clean-storage").off("click").on("click", () => {
			toUserPage();
		})
		$(".get-more-storage").off("click").on("click", () => {
			toVipPage();
		})
		function toUserPage() {
			const token = apower.user.apiToken;
			const href = `${recHref}/user/?api_token=${token}`;
			$("#storageLimitTip").css('display', 'none');
			$("#videoNumLimitTip").css('display', 'none');
			window.open(href, '_blank');
		}
		function toVipPage() {
			const token = apower.user.apiToken;
			const href = `${recHref}/vip/?api_token=${token}`;
			$("#storageLimitTip").css('display', 'none');
			$("#videoNumLimitTip").css('display', 'none');
			window.open(href, '_blank');
		}
		$("#pause-record").off("click").on("click", () => {
			if (recordStatus == "recording") {
				$("#pause-record").addClass("record-resume");
				$("#pause-record").removeClass("record-pause");
				$(".pause-resume-word.pause").hide();
				$(".pause-resume-word.resume").show();
				recordStatus = 'pause';
				recorder.pause();
			} else if (recordStatus == "pause") {
				$("#pause-record").removeClass("record-resume");
				$("#pause-record").addClass("record-pause");
				recordStatus = "recording";
				recorder.resume();
				$(".pause-resume-word.resume").hide();
				$(".pause-resume-word.pause").show();
			}
		})

		async function pointUpload(params = {}, isRec = false) {
			const id = isRec ? "293" : "035";
			const language = apower.lang;
			const browser = window.navigator.userAgent;
			const host = window.location.host;
			let url = `https://wx-user-behavior.cn-hongkong.log.aliyuncs.com/logstores/${id}/track?APIVersion=0.6.0&language=${language}&browser=${browser}&host=${host}`;
			const searchParams = new window.URLSearchParams();
			const mergeParams = {
				online_web: "1",
				...params
			};
			for (const paramsKey in mergeParams) {
				searchParams.append(paramsKey, mergeParams[paramsKey]);
			}
			if (searchParams.toString()) {
				url += `&${searchParams.toString()}`;
			}

			await fetch(url);
		}

		resisterPoint().then();

		/**
		 * 注册埋点
		 */
		async function resisterPoint() {
			const homeDownloadBtn = document.querySelector(".download-desktop a.download");
			homeDownloadBtn.onclick = function() {
				pointUpload({
					event: "click_download_app",
					download_location: "home"
				});
			};

			const dialogDownloadBtn = document.querySelector(".get-app a.download");
			dialogDownloadBtn.onclick = () => {
				pointUpload({
					event: "click_download_app",
					download_location: "pop-up"
				});
			};

			const moreDownloadBtn = document.querySelector(".more-download-app a.more-download-btn");
			moreDownloadBtn.onclick = function() {
				pointUpload({
					event: "click_download_app",
					download_location: "play_page"
				});
			};

			const questionDownloadBtn = document.querySelector(".question-container a.more-download-btn");
			questionDownloadBtn.onclick = function() {
				pointUpload({
					event: "click_download_app",
					download_location: "play_page_faq"
				});
			};
		}
	},
});

          })
        